const ACTION_KEY = 'HEALTH_STANDARDS_REPORTS_PDF';

const initialState = () => ({
  loading: false,
  data: null,
  errors: null
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false,
        errors: action.payload.errors
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        loading: false,
        data
      };
    }

    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
